import { render } from "./PromptEdit.vue?vue&type=template&id=5ae29a28"
import script from "./PromptEdit.vue?vue&type=script&lang=js"
export * from "./PromptEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__